import { AuthApiConfiguration } from '@portal/pkg-api/config'
import { EffectiveUserBasic, InfoApi as InfoApiClz, UserBasic } from '@portal/pkg-api/gen/auth'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import i18n from 'i18next'
import { data } from '@portal/pkg-api/shared'

export const InfoApi = new InfoApiClz(AuthApiConfiguration)

const prefix = 'shared.userInfo'

export const UserInfoQueries = {
  userInfo: () => ({
    queryKey: [`${prefix}.userInfo`],
    queryFn: () => data(InfoApi.getUserInfo({ mercatusNotifyOnError: false })),
  }),
}

export function useUserInfo() {
  return useQuery(UserInfoQueries.userInfo())
}

export function useEffectiveUser() {
  const { data } = useUserInfo()
  return useMemo<UserBasic | undefined>(() => resolveEffectiveUser(data), [data])
}

export function resolveEffectiveUser(
  userInfo: EffectiveUserBasic | undefined,
): UserBasic | undefined {
  return userInfo?.impersonated
    ? convert(userInfo.impersonated)
    : userInfo?.real
      ? convert(userInfo.real)
      : undefined
}

function convert(userInfo: UserBasic | undefined) {
  if (userInfo) {
    const { givenName, familyName, active, enabled } = userInfo
    const activeEnabled = active && enabled
    return {
      ...userInfo,
      displayName: i18n.t(activeEnabled ? 'displayName' : 'displayName_inactive', {
        givenName,
        familyName,
      }),
    }
  } else {
    return userInfo
  }
}
